var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFooter3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_116",
    "data-name": "Group 116",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34.856 34.874",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_115",
    "data-name": "Group 115",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_297",
    "data-name": "Path 297",
    className: "cls-1",
    d: "M303.715,1.954c.018.042.024.078.036.114.006.012.006.024.012.036l1.888,3.306h5.687L313.226,2.1c.012-.012.012-.024.018-.036.012-.036.018-.072.036-.114s.012-.072.018-.114c0-.012.006-.024.006-.036a.753.753,0,0,0-.018-.114V1.635C313,.054,308.969,0,308.494,0s-4.509.054-4.785,1.635v.054a.779.779,0,0,0-.024.114c0,.012.012.024.012.036C303.7,1.882,303.709,1.918,303.715,1.954Z",
    transform: "translate(-282.656 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_430",
    "data-name": "Rectangle 430",
    className: "cls-1",
    width: 4.809,
    height: 1.202,
    transform: "translate(23.433 6.613)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_298",
    "data-name": "Path 298",
    className: "cls-1",
    d: "M247.546,39.679a4.162,4.162,0,0,0,.192-1.323c0-1.683-1.822-3.186-2.032-3.355-.012-.012-.024-.012-.048-.024a.335.335,0,0,0-.1-.054.383.383,0,0,0-.108-.036.733.733,0,0,0-.114-.006.807.807,0,0,0-.114.006.383.383,0,0,0-.108.036.389.389,0,0,0-.1.054c-.024.012-.036.012-.048.024-.21.168-2.038,1.671-2.038,3.355a3.979,3.979,0,0,0,.2,1.323Z",
    transform: "translate(-226.109 -32.465)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_299",
    "data-name": "Path 299",
    className: "cls-1",
    d: "M34.986,108.35a1.806,1.806,0,0,0-1.809-1.8H33.17a1.758,1.758,0,0,0-1.256.523l-3.18,3.1c-.114-.006-.234-.018-.361-.018V105.94H23.563v4.208h-2.4v-2.4H17.552v2.4h-1.8v-6.012H12.141v6.012h-1.2v-3.607a1.206,1.206,0,0,0-1.2-1.2v-1.2H5.528v1.2a1.21,1.21,0,0,0-1.2,1.2v3.745a5.407,5.407,0,0,0-4.2,5.278l.012,16.213,33.623.018.012-16.231a5.338,5.338,0,0,0-1.545-3.787l2.224-2.152A1.8,1.8,0,0,0,34.986,108.35ZM2.523,128.79a.6.6,0,0,1-1.2,0v-2.4a.6.6,0,0,1,1.2,0Zm0-4.809a.6.6,0,1,1-1.2,0v-7.815a.6.6,0,1,1,1.2,0Zm21.738-3.312L17.389,128a.59.59,0,0,1-.872,0l-6.871-7.328a4.235,4.235,0,0,1,0-5.705,3.7,3.7,0,0,1,5.453-.006l1.852,1.984,1.858-1.978a3.692,3.692,0,0,1,5.453,0A4.236,4.236,0,0,1,24.261,120.668Zm9.354-11.9-2.321,2.248a5.254,5.254,0,0,0-1.136-.559l2.6-2.531a.591.591,0,0,1,.421-.174.544.544,0,0,1,.433.18A.6.6,0,0,1,33.615,108.765Z",
    transform: "translate(-0.13 -96.922)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_300",
    "data-name": "Path 300",
    className: "cls-1",
    d: "M74.834,1.2a1.206,1.206,0,0,0-1.2-1.2H70.626a1.206,1.206,0,0,0-1.2,1.2V6.012h5.411V1.2Z",
    transform: "translate(-64.624)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_431",
    "data-name": "Rectangle 431",
    className: "cls-1",
    width: 3.607,
    height: 1.202,
    transform: "translate(17.425 8.416)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_301",
    "data-name": "Path 301",
    className: "cls-1",
    d: "M177.983,35.625a1.2,1.2,0,0,0-2.339.03l-.523,2.663h3.391Z",
    transform: "translate(-162.998 -32.307)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_302",
    "data-name": "Path 302",
    className: "cls-1",
    d: "M150.62,260.426h0a2.53,2.53,0,0,0-1.853.821l-2.287,2.445a.62.62,0,0,1-.878,0l-2.288-2.447a2.529,2.529,0,0,0-1.851-.819h0a2.519,2.519,0,0,0-1.845.82,3.012,3.012,0,0,0,0,4.064l6.427,6.861,6.426-6.86h0a3.011,3.011,0,0,0,0-4.064A2.519,2.519,0,0,0,150.62,260.426Z",
    transform: "translate(-129.215 -242.385)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooter3);
export default __webpack_public_path__ + "static/media/footer_3.22f93969ddc955d2b9b9c634c941a41b.svg";
export { ForwardRef as ReactComponent };